export default __webpack_public_path__ + "static/media/match-formats.b207eb56.svg";